import { userService } from "../services/user.services";
import { syncAuthToLocalStorage, clearAuthData } from "./AuthSync";

const refreshIdToken = async () => {
    const response = await userService.RefreshToken();
    if (response?.error === false && response?.data?.success_status === true) {
        sessionStorage.setItem('IdToken', response.data.data);
        // Sync updated token to localStorage for cross-tab access
        syncAuthToLocalStorage();
    } else {
        if(response?.message?.response?.status===400){
            const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
            const logoutFromAllTabs = localStorage.getItem('LogoutfromAllTabs');
            sessionStorage.setItem('custom-status', 'inactive');
            
            // Clear all auth data from both sessionStorage and localStorage to prevent refresh loop
            clearAuthData();
            
            // Restore browser trust token and logout flag if they exist
            if (browserIdValue) {
                localStorage.setItem('arcm_trust_browser_token', browserIdValue);
            }
            if (logoutFromAllTabs) {
                localStorage.setItem('LogoutfromAllTabs', logoutFromAllTabs);
            }
            
            window.location.href = '/';
        }
    }
}

export default refreshIdToken;